import {formsSession} from './formsOfflineSession';

/** Starts the auto-cached forms session once signed in (idempotent, guarded). */
export const useFormsOfflineAutoSession = (): void =>
  formsSession.useAutoSession();
